import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCurrentUser = (token) => {
    return fetch(`${apiUrl}auth/me/`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getCurrentUser